<script>
import {defineComponent, ref} from "vue";

import FileUpload from "primevue/fileupload";
import Button from "primevue/button";

export default defineComponent({
  components: {FileUpload, Button},
  props: {
    label: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      required: false,
    },
    accept: {
      type: String,
      required: false,
    },
    multiple: {
      type: Boolean,
      required: false,
    },
    clearFilesAfterSelect: {
      type: Boolean,
      required: false,
    },
    classes: {
      type: Object,
      required: false
    },
    index: {
      type: Number,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: false
    },
    buttonText: {
      type: Boolean,
      required: false
    },
    withPlus: {
      type: Boolean,
      required: false
    },
    text: {
      type: Boolean,
      required: false
    }
  },
  emits: ['chooseFiles'],
  setup(props, {emit}) {
    const upload = ref();
    const filesArray = ref([]);

    const toSelect = (files) => {
      filesArray.value = files;

      if (props.clearFilesAfterSelect === true) {
        upload.value.clear();
      }
      if(props.index || props.index === 0) {
        emit('chooseFiles' , filesArray.value, props.index);
      } else {
        emit('chooseFiles' , filesArray.value);
      }
    }

    return {upload, toSelect};
  }
});
</script>

<template>
  <div class="hidden">
    <FileUpload
        :mode="mode ? mode : 'advanced'"
        :accept="accept ? accept : 'image/*'"
        :multiple="multiple ?? true"
        name="demo[]"
        @select="toSelect"
        ref="upload"
    />
  </div>
  <span v-if="buttonText" @click="upload.choose()" :loading="isLoading" :class="classes ? classes : {}" class="color-primary underline cursor-pointer" >{{ label }}</span>
  <Button v-else :label="label" :text="text" @click="upload.choose()" :loading="isLoading" :class="classes ? classes : {}" class="btn-primary btn-fix-height font-light" />
  <svg v-if="withPlus" class="btn-primary__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4V20M20 12H3.99998" stroke="#C3987A" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>